/**
 * SpoilerGate — hides spoiler content behind an explicit reveal.
 */

import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, Eye } from 'lucide-react';

export default function SpoilerGate({ children, compact = false }) {
  const [revealed, setRevealed] = useState(false);

  if (revealed) return children;

  return (
    <div className={compact
      ? 'flex items-center gap-2 rounded-lg border border-dashed border-coral/40 bg-coral/5 px-3 py-2'
      : 'rounded-xl border border-dashed border-coral/40 bg-coral/5 px-4 py-4'}
    >
      <div className={compact ? 'flex flex-1 items-center gap-2' : 'flex items-center gap-2'}>
        <AlertTriangle className="h-3.5 w-3.5 shrink-0 text-coral" />
        <span className="text-xs font-semibold text-coral">Contains spoilers</span>
      </div>
      <AnimatePresence>
        <motion.button
          type="button"
          onClick={() => setRevealed(true)}
          whileTap={{ scale: 0.96 }}
          className={compact ? 'ml-auto inline-flex items-center gap-1 text-xs font-semibold text-coral hover:underline' : 'mt-2 inline-flex items-center gap-1.5 text-xs font-semibold text-coral hover:underline'}
        >
          <Eye className="h-3.5 w-3.5" /> Reveal spoiler
        </motion.button>
      </AnimatePresence>
    </div>
  );
}
